"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiManagersEvent = void 0;
exports.UiManagersEvent = {
    UPDATE_COMPONENTS: 'UPDATE_COMPONENTS'
};
